// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "coming_soon" + "." + "3a3e5aec" + ".js";
};